import { FeatureFlagDetail } from "@/domain/entities/Account";

const getDataSessionStorage = (key: string): any => {
  return sessionStorage.getItem(key);
};
const storeDatatoSessionStorage = (key: string, data: any) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};
const removeDataSessionStorage = (key: string) => {
  sessionStorage.removeItem(key);
};
const updateSessionStorageFeatureFlag = (keyName: string) => {
  const flagData = JSON.parse(sessionStorage.getItem("FeatureFlag") || "[]");

  if (flagData && flagData.length) {
    const result = flagData.findIndex((key: FeatureFlagDetail) =>
      key.keyName.includes(keyName)
    );
    flagData[result].keyValue = false;
  }
  storeDatatoSessionStorage("FeatureFlag", flagData);
};
const clearDataSessionStorage = () => {
  sessionStorage.clear();
};

export {
  getDataSessionStorage,
  storeDatatoSessionStorage,
  removeDataSessionStorage,
  updateSessionStorageFeatureFlag,
  clearDataSessionStorage
};
